/**
 * Author(s) : Adheesh
 * Purpose : This component displays different categories in the main event
 */

import styles from './CategoryCardDetail.module.scss';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { CATEGORY_CARD_CONSTANTS, SCHEDULE_ROUTE } from '../../constants';


const CategoryCardDetail = ({ title, image, description, date }) => {
  return (
    <div className={styles.categoryCardContainer}>
      <div className={styles.categoryImage}>
        <img src={image} alt={title} />
      </div>
      <div className={styles.categoryContent}>
        <div className={styles.categoryTitle}>{title}</div>
        <div className={styles.categoryDescription}>{description}</div>
        <div className={styles.categoryDate}>{date}</div>
        <div className={styles.navButton}>
          <NavLink to={SCHEDULE_ROUTE}>
            <span>{CATEGORY_CARD_CONSTANTS.VIEW_SCHEDULE}</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

CategoryCardDetail.defaultProps = {
  title: CATEGORY_CARD_CONSTANTS.TITLE,
  image: CATEGORY_CARD_CONSTANTS.FALLBACK_IMAGE,
  description: CATEGORY_CARD_CONSTANTS.DESCRIPTION,
  date: CATEGORY_CARD_CONSTANTS.DATE,
};

CategoryCardDetail.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  description: PropTypes.string.isRequired,
  date: PropTypes.string,
};

export default CategoryCardDetail;
